import { render, staticRenderFns } from "./todayEat.vue?vue&type=template&id=1235492e&scoped=true"
import script from "./todayEat.vue?vue&type=script&lang=js"
export * from "./todayEat.vue?vue&type=script&lang=js"
import style0 from "./todayEat.vue?vue&type=style&index=0&id=1235492e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235492e",
  null
  
)

export default component.exports